import ajax from "./ajax";

// src/actions/customer.js
export function signUp(params) {
  // Pehle yahan '' khali tha, ab humne sahi path daal diya hai
  return ajax("/Auth/signup", {
    method: "POST",
    data: params,
  });
}

export function login(params) {
  return ajax("/Auth/login", { method: "POST", data: params });
}

export function loginUsingEmail(params) {
  return ajax("/customers/login_using_email", { method: "POST", data: params });
}

export function resendOtp(otp) {
  return ajax("/ForgotPassword/resend-otp", { method: "POST", data: otp });
}

export function resendMobileOtp(otp) {
  return ajax("/Auth/resend-signup-otp", { method: "POST", data: otp });
}

export function updateProfile(params) {
  return ajax(`/UserProfile/me`, { method: "PUT", data: params });
}
export function updateProfileEmployer(params) {
  return ajax(`/UserProfile/update-basic-info`, {
    method: "PUT",
    data: params,
  });
}

// API FILE

export function uploadResume(params) {
  return ajax(`/CandidateAttachment/UploadResume`, {
    method: "POST",
    data: params, // This must be new FormData()
    attachment: true, // This triggers the fix above
  });
}
export function getCustomerDetails(userId) {
  return ajax(`/UserProfile/${userId}`);
}

export function getCustomerPublicDetails(userId) {
  return ajax(`/Candidate/GetCandidateById/${userId}`);
}

export function getCustomerDetailsByParams(params) {
  return ajax(`/customers?${params}`);
}

export function getCustomerFullDetails(userId) {
  return ajax(`/Candidate/${userId}/employer-view`);
}
export function downloadDocument(token, field = "resume") {
  return ajax(`/customers/download_document?field=${field}&token=${token}`);
}

export function forgetPassword(params) {
  return ajax("/ForgotPassword/SendPhoneOtp", { method: "POST", data: params });
}

export function verifyEmailOtp(params) {
  return ajax("/customers/verify_email_otp", { method: "POST", data: params });
}

export function forgotEmailPassword(params) {
  return ajax("/ForgotPassword/SendEmailOtp", { method: "POST", data: params });
}

export function verifyEmailForgotPasswordOtp(params) {
  return ajax("/ForgotPassword/VerifyOtp", { method: "POST", data: params });
}
export function resetPassword(params) {
  return ajax("/ForgotPassword/ResetPassword", {
    method: "POST",
    data: params,
  });
}
export function retypepassword(params) {
  return ajax("/ForgotPassword/VerifyOtp", { method: "POST", data: params });
}

export function verifyMobileForgotPasswordOtp(params) {
  return ajax("/ForgotPassword/VerifyOtp", {
    method: "POST",
    data: params,
  });
}

export function verifyMobileOtp(params) {
  return ajax("/Auth/verify-otp", { method: "POST", data: params });
}

// Using GET with query parameters
export function verifyEmailLink(token) {
  return ajax(`/Auth/verify-email?token=${token}`, { method: "GET" });
}

export function ResendverifyEmailLink(token) {
  return ajax(`/Auth/resend-verification-email`, { method: "POST" });
}

export function changePassword(params) {
  return ajax("/Auth/ChangePassword", { method: "POST", data: params });
}

export function getCustomerList(
  customerType,
  params = "",
  pageSize = 10,
  page = 1,
  sort = "-id",
) {
  console.log("DEBUG - Arguments received:", { customerType, params, pageSize, page, sort });
  
  const extraParams = params && !params.startsWith("&") ? `&${params}` : params;

  return ajax(
    `Candidate/GetAllCandidates?page=${page}&pageSize=${pageSize}&sort=${sort}${extraParams}`,
  );
}

export function getDocuments(documentType, token) {
  return ajax(
    `customers/download_document?field=${documentType}&token=${token}`,
  );
}

export function getPlanDetails() {
  return ajax(`/PlanDetails/plan-details
`);
}

export function changeLoginField(params) {
  return ajax("/EmailUpdate/request", { method: "POST", data: params });
}

export function changeLoginFieldConfirmation(params) {
  return ajax("/EmailUpdate/verify", { method: "POST", data: params });
}

export function changeLoginFieldMobile(params) {
  return ajax("/PhoneUpdate/send-otp", { method: "POST", data: params });
}

export function changeLoginFieldConfirmationMobile(params) {
  return ajax("/PhoneUpdate/verify-otp", { method: "POST", data: params });
}
